.card {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  height: 100%;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mark {
  color: var(--mantine-color-samfundet-red-3);
  flex-shrink: 0;
}

/* Keep the line breaks, so a dialogue stays one line per person. */
.text {
  white-space: pre-line;
  overflow-wrap: anywhere;
  color: var(--mantine-color-dark-7);
  font-weight: 500;
  line-height: 1.45;
}

.footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mantine-spacing-xs);
}

.actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
